import { useState } from 'react';
import { useAuth } from './';
import { editBusinessHourApi } from '../api/businessHoursApi';

export const useBusinessHours = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const {auth} = useAuth();

  const editBusinessHour = async (id, data) => {
    try {
      setLoading(true);
      setError(null);
      const updated = await editBusinessHourApi(id, data, auth.token);
      setLoading(false);
      return updated;
    } catch (err) {
      setLoading(false);
      setError(err);
      throw err;
    }
  };

  return {
    editBusinessHour,
    loading,
    error,
  };
};
